import DashboardDealCard from "./DashboardDealCard";

export default DashboardDealCard;
